import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import { createPinia } from 'pinia'
import piniaPersist from 'pinia-plugin-persist'
import useApi from './api'
import directives from './directives/index.js'
import 'ant-design-vue/dist/reset.css'
import '@/assets/styles/main.scss'

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPersist)
app.provide('$api', useApi)

app.use(pinia).use(router).use(directives).use(Antd).mount('#app')
